import { createRouter, createWebHistory } from 'vue-router'
import PrayerWall from '@/views/PrayerWall.vue'
import LoginHome from "@/views/LoginHome.vue"
import AdminWall from "@/views/AdminWall.vue"
import AdminWalls from "@/views/AdminWalls.vue"
import InputForm from "@/views/InputForm.vue"
import WallOverview from "@/views/WallOverview.vue"
import WallInfo from "@/views/WallInfo.vue"
import WallIntegrationsOverview from "@/views/WallIntegrationsOverview.vue"
import SignUp from "@/views/Signup.vue";
import SlideShow from "@/views/Slideshow.vue";

import store from "@/store"

const routes = [
  {
    path: '/walls/:clientId',
    name: 'PrayerWall',
    component: PrayerWall
  },
  {
    path: '/walls/:clientId/submit',
    name: 'PrayerSubmit',
    component: InputForm
  },
  {
    path: '/walls/:clientId/slideshow',
    name: 'SlideShow',
    component: SlideShow
  },
  {
    path: "/admin/walls/:clientId",
    name: "AdminWall",
    component: WallOverview,
    children: [
      {
        path: "manage",
        name: "ManageWall",
        component: AdminWall
      },
      {
        path: "",
        name: "WallInfo",
        component: WallInfo
      },
      {
        path: "integrations",
        name: "WallIntegrationsOverview",
        component: WallIntegrationsOverview
      }

    ]
  },
  {
    path: "/admin/walls",
    name: "AdminWalls",
    component: AdminWalls
  },
  /*{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about"  '../views/About.vue')
  },*/
  {
    path: "/",
    name: "LoginHome",
    component: LoginHome
  },
  {
    path: "/signup",
    name: "SignUp",
    component: SignUp
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next)=>{
    if(to.path.startsWith("/admin/") && !store.state.userName && !store.state.userToken){
      next("/");
    }else{
      next();
    }
});

export default router
